import axios from "axios";
import { baseURL } from "../Constants";

const url = `${baseURL}/OverPass`;

export interface OverPassUsageRow {
    steamId: string;
    personaName: string | null;
    openCount: number;
    lastSeen: string | null;
    totalCalls: number;
    lastCalledAt: string | null;
    blocked: boolean;
    blockReason: string | null;
}

// Admin-only: per-user OverPass proxy usage joined with the blocklist (JWT must belong to an admin).
export const getOverPassUsage = async (): Promise<OverPassUsageRow[]> => {
    const token = localStorage.getItem("token");
    const response = await axios.get<OverPassUsageRow[]>(`${url}/admin/usage`, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
};

export const blockOverPassUser = async (steamId: string, reason?: string): Promise<void> => {
    const token = localStorage.getItem("token");
    await axios.post(`${url}/admin/block`, { steamId, reason: reason ?? null }, {
        headers: { Authorization: `Bearer ${token}` },
    });
};

export const unblockOverPassUser = async (steamId: string): Promise<void> => {
    const token = localStorage.getItem("token");
    await axios.post(`${url}/admin/unblock`, { steamId }, {
        headers: { Authorization: `Bearer ${token}` },
    });
};
